const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconMaterialArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392 392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M44,84h102c5.6,0,10.8,2.6,14.2,7l20.8,27h167c12.2,0,22,9.8,22,22v178c0,12.2-9.8,22-22,22H44     c-12.2,0-22-9.8-22-22V106C22,93.8,31.8,84,44,84z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 46,
    width: 168,
    height: 214,
    rx: 12,
    style: {
      fill: "#FFFFFF",
      stroke: "#194F82",
      strokeWidth: 14
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 76,
    width: 168,
    height: 196,
    rx: 12,
    style: {
      fill: "#FFFFFF",
      stroke: "#194F82",
      strokeWidth: 14
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#56ACE0",
      strokeWidth: 14,
      strokeLinecap: "round"
    },
    d: "M176,120h100 M176,152h100 M176,184h70"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0",
      stroke: "#194F82",
      strokeWidth: 14,
      strokeLinejoin: "round"
    },
    d: "M30,186c0-11,9-20,20-20h292c11,0,20,9,20,20     v134c0,11-9,20-20,20H50c-11,0-20-9-20-20V186z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 226,
    width: 100,
    height: 44,
    rx: 10,
    style: {
      fill: "#FFC10D",
      stroke: "#194F82",
      strokeWidth: 12
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconMaterialArchive);
export default __webpack_public_path__ + "static/media/common_icon_material_archive.ed836cbf184852a7040519e492705757.svg";
export { ForwardRef as ReactComponent };